import React from 'react'
import * as yup from 'yup';
import Button from '../../Reusable/Button';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useForm } from 'react-hook-form';
import TextField from '../../Reusable/TextInput';
//@ts-ignore
import { tw } from "@careinfo/tailwind";
let reverseOrderValidationForm = yup.object().shape({
  refund_amount: yup.string().required("Refund Amount is required"),
  delivery_charge:yup.string().required("Delivery Charge is required"),
});


const ReturnRTV = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError
  } = useForm<any>({
    resolver: yupResolver(reverseOrderValidationForm),
    defaultValues: async () => {
      return {
        refund_amount: 0,
        delivery_charge:props?.chargevalue
      }
    }
  })
  return (
    <div className={tw`flex flex-col justify-between min-h-full`}>
      <h1 className={tw`text-sm text-gray-500`}>Are you sure you want to return? It will create return order.</h1>
      <TextField
        label={"Refund Amount"}
        register={register("refund_amount")}
        errors={errors?.refund_amount}
      />
      <TextField
        label={"Delivery Charge"}
        register={register("delivery_charge")}
        errors={errors?.delivery_charge}
      />
      <div className={tw`w-[100px] mr-4 absolute bottom-4 right-2`}>
        <Button
          label={"Submit"}
          onClick={handleSubmit((data: any) =>
            props?.handleActionMenu(data,"RTV/Return" , setError)
          )}
        />
      </div>
    </div>
  )
}

export default ReturnRTV
